import { shallowMount } from "@vue/test-utils";
import ChangePhone from "@/components/core/modals/ChangePhone";

describe("ChangePhone Component mount", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ChangePhone, {
      propsData: {
        value: {},
        show: true
      }
    });
  });

  it("Renders del component ChangePhone", () => {
    expect(wrapper).toBeDefined();
  });
});
